import networkTS from '@/misc/apis/networkTS'
import { ApplicableApplicable } from '@/types/api'

export default {
  async enableEvorest(accountId: string, enable: boolean, apiKey: string, allowSwissCaution: boolean) {
    return networkTS.evorestServiceEnable(accountId, { enable: enable, apiKey: apiKey, allowSwissCaution: allowSwissCaution })
      .then((response) => {
        return response.data
      })
  },
  async getEvorestAccountSettings(accountId: string) {
    return networkTS.evorestServiceGetAccountSettings(accountId)
      .then(response => {
        return response.data
      })
  },
  async hasEvorestEnabled(accountId: string) {
    return networkTS.evorestServiceHasEnabled(accountId)
      .then((response) => {
        return response.data
      })
  },
  async getOwnerConfig(accountId: string) {
    return networkTS.evorestServiceGetOwnerConfig(accountId)
      .then((response) => {
        return response.data
      })
  },
  async setOwnerConfig(accountId: string, allowInvestment: ApplicableApplicable) {
    return networkTS.evorestServiceSetOwnerConfig(accountId, { allowInvestment: allowInvestment })
      .then((response) => {
        return response.data
      })
  },
  async openDeposit(objectId: string, tenancyId: string, allowInvestment: boolean, contactPersonId: string = '') {
    return networkTS.evorestServiceOpenDeposit({
      objectId: objectId,
      tenancyId: tenancyId,
      allowInvestment: allowInvestment,
      contactPersonId: contactPersonId
    })
      .then((response) => {
        return response.data
      })
  },
  async getDepositInfo(tenancyId: string) {
    return networkTS.evorestServiceGetDepositInfo(tenancyId)
      .then((response) => {
        return response.data
      })
  }
}
